import { handleActions } from 'redux-actions';

import reducersUtils from 'state/utils';

import actions from 'state/editLog/actionCreators';
import { types as orderActionTypes } from 'state/order';

import initialState from 'state/editLog/initial.state';

const editLog = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [orderActionTypes.cleanRepeatAndEditing$]: () => initialState,
    [actions.setLog]: (state, { payload: { log } }) => [...(state || []), log],
  },
  initialState
);

export default editLog;
